import React, { memo } from "react";
import { CardWithExpectation } from "./card";
import { expectationList } from "./data.js";
import styles from "./styles.module.css";

export const ABOUT_SECTION_ID = "about";

export const ExpectationsSection = memo(() => {
  function getSizeBasedOnIndex(index) {
    const small = styles.cardWidthS;
    const big = styles.cardWidthM;
    const sizes = [small, big, big, small];

    return sizes[index];
  }

  return (
    <div
      id={ABOUT_SECTION_ID}
      style={{ backgroundColor: "#070809", padding: "1px" }}
    >
      <div className={styles.container}>
        <div className={styles.containerForTitle}>
          <div className={styles.flex}>
            <div className={styles.title}>DAO</div>
          </div>
          <div className={styles.text}>
            Изучай крипту в сообществе единомышленников, учись Solidity у
            крипто-нейтивов, тренируйся на совместных проектах, устраивайся в
            компании мирового уровня.
          </div>
        </div>
        <div className={styles.containerCards}>
          {expectationList.map((expectation, index) => (
            <CardWithExpectation
              key={expectation.id}
              className={getSizeBasedOnIndex(index)}
              data={expectation}
            />
          ))}
        </div>
      </div>
    </div>
  );
});
